const { default: Swiper } = require('swiper');
const {
    swiperNavigation,
    handleSwiperProgressBar,
} = require('../modules/swiperModules');
const { Navigation, Mousewheel } = require('swiper/modules');
const { Loader } = require('../modules/Loader');
const {
    addInspirationAllToCart,
    exportInspirationShoppingListPdf,
    openInspirationSidebar,
} = require('../modules/inspirations/inspiration-api');

const inspirationHost = {
    inspirationSidebar: null,
    activeInspirationTermId: 0,
    loader: new Loader(),
};

const openInspirationFromCard = async termId => {
    inspirationHost.loader?.show();

    try {
        await openInspirationSidebar(inspirationHost, termId);
    } finally {
        inspirationHost.loader?.hide();
    }
};

const sections = document.querySelectorAll('.categories-cards');

if (sections.length) {
    sections.forEach(section => {
        const swiperElement = section.querySelector('.swiper');
        const desktopCols = section.getAttribute('data-desktop-cols') ?? 3;

        if (swiperElement) {
            const paginationEl =
                swiperElement.querySelector('.slider-pagination');
            const arrowsEl = swiperElement.querySelector('.slider-arrows');

            let args = {
                modules: [Navigation, Mousewheel],
                direction: 'horizontal',
                mousewheel: {
                    enabled: true,
                    forceToAxis: true,
                    invert: false,
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1.08,
                        slidesPerGroup: 1,
                        spaceBetween: 16,
                    },
                    576: {
                        slidesPerView: 2,
                        slidesPerGroup: 1,
                        spaceBetween: 16,
                    },
                    1023.98: {
                        slidesPerView: desktopCols,
                        slidesPerGroup: 1,
                        spaceBetween: 20,
                    },
                },
            };

            if (arrowsEl) {
                args = { ...args, ...swiperNavigation(arrowsEl) };
            }

            const swiper = new Swiper(swiperElement, args);

            if (paginationEl) {
                handleSwiperProgressBar(paginationEl, swiper);
            }
        }

        section.addEventListener('click', event => {
            const trigger = event.target.closest(
                '[data-inspiration-open], [js-inspiration-card]'
            );

            if (!trigger || !section.contains(trigger)) {
                return;
            }

            const card =
                trigger.closest('[js-inspiration-card]') || trigger;
            const termId = Number(card?.dataset?.termId || 0);

            if (termId <= 0) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();
            void openInspirationFromCard(termId);
        });
    });
}

document.addEventListener('click', event => {
    if (
        !inspirationHost.inspirationSidebar?.content?.contains(event.target)
    ) {
        return;
    }

    const exportPdfButton = event.target.closest(
        '[data-inspiration-export-pdf]'
    );

    if (exportPdfButton) {
        event.preventDefault();
        event.stopPropagation();

        const termId = Number(
            inspirationHost.activeInspirationTermId ||
                exportPdfButton.dataset.termId ||
                0
        );

        if (termId > 0) {
            void exportInspirationShoppingListPdf(inspirationHost, termId);
        }

        return;
    }

    const addAllButton = event.target.closest(
        '[data-inspiration-add-all-to-cart]'
    );

    if (addAllButton) {
        event.preventDefault();
        event.stopPropagation();

        if (
            addAllButton.disabled ||
            addAllButton.getAttribute('aria-disabled') === 'true'
        ) {
            return;
        }

        const termId = Number(
            inspirationHost.activeInspirationTermId ||
                addAllButton.dataset.termId ||
                0
        );

        if (termId > 0) {
            void addInspirationAllToCart(inspirationHost, termId);
        }
    }
});
